module.exports = __webpack_public_path__ + "static/img/env22.79cbfdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env22.png
// module id = 588
// module chunks = 4